import * as utils from "../../utils/utils.js";

export default function () {
  const widgetName = "agZoneSeoBlock";
  const widgetOpts = agZoneSeoBlockOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    showDescription: true,
    hasImages: true,
    textOverImage: true,
    imageIsBackground: true,
    buyNowButton: false,
    lazyLoadImages: false,
    link: [""],
    moreButton: {
      visible: true,
      text: "Learn More",
    },
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $(".tier-2-container").remove();
      } else {
        createCustomSeo(data.items);
      }
    },
  });

  function createCustomSeo(widgetData) {
    const { DetailLinkText, Title, URL } = widgetData[0];
    const $seoItem = $(`#${widgetName}`).find(".card-widget-item");

    $(`#${widgetName}`).find(".card-widget-title").remove();
    $seoItem.prepend(
      `<h1 class="card-widget-title" aria-label="${DetailLinkText} ${Title}">
            <span>${DetailLinkText}</span>
            <span>${Title}</span>
          </h1>`
    );

    $seoItem
      .find(".buttonwrap .moreButton")
      .addClass("button")
      .removeClass("moreButton");

    if (!utils.isLocalUrl(URL)) {
      $seoItem.find(".buttonwrap .button").attr("target", "_blank");
    }
  }
}
